import MeshManage from '../meshManage';
import { BASICLENGTHTYPE_ENUM, AXES_TYPE, LengthType, } from '../utils/enum';
import { checkFrameIsHighFrame } from '../utils/renderUtils';
class SealPlate {
    constructor(scene, sealPlateData) {
        this.scene = scene;
        this.sealPlateData = sealPlateData;
    }
    /**
     * @param templateJson templateJon数据
     * @returns 处理后加载模型的每条边的补板数据
     */
    static getSealPlatesAssets(templateJson) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17;
        const loadLength1 = ((_b = (_a = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.sealPlate) && ((_e = (_d = (_c = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _c === void 0 ? void 0 : _c.length1) === null || _d === void 0 ? void 0 : _d.sealPlate[0]) === null || _e === void 0 ? void 0 : _e.width)
            ? (_g = (_f = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _f === void 0 ? void 0 : _f.length1) === null || _g === void 0 ? void 0 : _g.sealPlate : null;
        const loadLength2 = ((_j = (_h = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _h === void 0 ? void 0 : _h.length2) === null || _j === void 0 ? void 0 : _j.sealPlate) && ((_m = (_l = (_k = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _k === void 0 ? void 0 : _k.length2) === null || _l === void 0 ? void 0 : _l.sealPlate[0]) === null || _m === void 0 ? void 0 : _m.width)
            ? (_p = (_o = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _o === void 0 ? void 0 : _o.length2) === null || _p === void 0 ? void 0 : _p.sealPlate : null;
        const loadLength3 = ((_r = (_q = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _q === void 0 ? void 0 : _q.length3) === null || _r === void 0 ? void 0 : _r.sealPlate) && ((_u = (_t = (_s = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _s === void 0 ? void 0 : _s.length3) === null || _t === void 0 ? void 0 : _t.sealPlate[0]) === null || _u === void 0 ? void 0 : _u.width)
            ? (_w = (_v = templateJson === null || templateJson === void 0 ? void 0 : templateJson.bottom) === null || _v === void 0 ? void 0 : _v.length3) === null || _w === void 0 ? void 0 : _w.sealPlate : null;
        const loadLength4 = ((_y = (_x = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _x === void 0 ? void 0 : _x.length1) === null || _y === void 0 ? void 0 : _y.sealPlate) && ((_1 = (_0 = (_z = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _z === void 0 ? void 0 : _z.length1) === null || _0 === void 0 ? void 0 : _0.sealPlate[0]) === null || _1 === void 0 ? void 0 : _1.width)
            ? (_3 = (_2 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _2 === void 0 ? void 0 : _2.length1) === null || _3 === void 0 ? void 0 : _3.sealPlate : null;
        const loadLength5 = ((_5 = (_4 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _4 === void 0 ? void 0 : _4.length2) === null || _5 === void 0 ? void 0 : _5.sealPlate) && ((_8 = (_7 = (_6 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _6 === void 0 ? void 0 : _6.length2) === null || _7 === void 0 ? void 0 : _7.sealPlate[0]) === null || _8 === void 0 ? void 0 : _8.width)
            ? (_10 = (_9 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _9 === void 0 ? void 0 : _9.length2) === null || _10 === void 0 ? void 0 : _10.sealPlate : null;
        const loadLength6 = ((_12 = (_11 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _11 === void 0 ? void 0 : _11.length3) === null || _12 === void 0 ? void 0 : _12.sealPlate) && ((_15 = (_14 = (_13 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _13 === void 0 ? void 0 : _13.length3) === null || _14 === void 0 ? void 0 : _14.sealPlate[0]) === null || _15 === void 0 ? void 0 : _15.width)
            ? (_17 = (_16 = templateJson === null || templateJson === void 0 ? void 0 : templateJson.top) === null || _16 === void 0 ? void 0 : _16.length3) === null || _17 === void 0 ? void 0 : _17.sealPlate : null;
        const sidePlatesJson = [
            // templateJson?.bottom?.length1?.sealPlate,
            // templateJson?.bottom?.length2?.sealPlate,
            // templateJson?.bottom?.length3?.sealPlate,
            // templateJson?.top?.length1?.sealPlate,
            // templateJson?.top?.length2?.sealPlate,
            // templateJson?.top?.length3?.sealPlate,
            loadLength1,
            loadLength2,
            loadLength3,
            loadLength4,
            loadLength5,
            loadLength6,
        ];
        const sealPlatesAssets = sidePlatesJson.map((item) => {
            if (item) {
                return item.map((ele) => (Object.assign(Object.assign({}, ele), { componentBasic: ele })));
            }
            return undefined;
        });
        return sealPlatesAssets;
    }
    /**
     *
     * @param meshManage 当前需要scale的mesh
     * @param rotation 旋转角度
     * @param scalings 缩放尺寸
     */
    static setChangeDoorScale(meshManage, rotation, scalings) {
        var _a, _b, _c, _d, _e;
        const newMesh = meshManage;
        const scale = {
            x: scalings.x / ((_a = meshManage === null || meshManage === void 0 ? void 0 : meshManage.getModelSize()) === null || _a === void 0 ? void 0 : _a.x),
            y: scalings.y / ((_b = meshManage === null || meshManage === void 0 ? void 0 : meshManage.getModelSize()) === null || _b === void 0 ? void 0 : _b.y),
            z: scalings.z / ((_c = meshManage === null || meshManage === void 0 ? void 0 : meshManage.getModelSize()) === null || _c === void 0 ? void 0 : _c.z),
        };
        // 1：没有缩放  2：切换门板是先旋转后缩放 ，所以缩放的 x需要根据rotation判断
        if (!rotation || ((rotation === null || rotation === void 0 ? void 0 : rotation.x) === 0 && (rotation === null || rotation === void 0 ? void 0 : rotation.y) === 0 && (rotation === null || rotation === void 0 ? void 0 : rotation.z) === 0)) {
            scale.x = scalings.x / ((_d = meshManage.getModelSize()) === null || _d === void 0 ? void 0 : _d.x);
        }
        else {
            scale.x = scalings.z / ((_e = meshManage.getModelSize()) === null || _e === void 0 ? void 0 : _e.z);
        }
        const { x, y, z } = scale;
        newMesh.mesh.scaling.x = x;
        newMesh.mesh.scaling.y = y;
        newMesh.mesh.scaling.z = z;
    }
    /**
     * @description 返回缩放后的MeshManage
     * @param {string} vector 方向 x/y/z
     * @param {object} meshManage meshManage
     * @returns {} 缩放后的meshManage
     */
    // eslint-disable-next-line class-methods-use-this
    setSealPlatesScale(meshManage, scaleX = 1, scaleY = 1, scaleZ = 1) {
        if (!meshManage.mesh) {
            return;
        }
        // meshManage.mesh.scaling = new Vector3(scaleX, scaleY, scaleZ);
        // eslint-disable-next-line no-param-reassign
        meshManage.mesh.scaling.x = scaleX;
        // eslint-disable-next-line no-param-reassign
        meshManage.mesh.scaling.y = scaleY;
        // eslint-disable-next-line no-param-reassign
        meshManage.mesh.scaling.z = scaleZ;
    }
    /**
     *
     * @param lengthType
     * @param lastLenghMesh
     * @param meshManage
     * @param vector
     * @param lastPos
     * @description 渲染补板位置
     */
    // eslint-disable-next-line class-methods-use-this
    setSealPlatePos(lengthType, lastLenghMesh, meshManage, vector, lastPos) {
        switch (lengthType) {
            case BASICLENGTHTYPE_ENUM.length1:
                // eslint-disable-next-line no-case-declarations
                const moveZ = vector === AXES_TYPE.font
                    ? lastLenghMesh.getModelSize().z * 0.5
                    : -lastLenghMesh.getModelSize().z * 0.5;
                meshManage.setModelPosition({
                    x: lastPos.x - lastLenghMesh.getModelSize().x * 0.5 - meshManage.getModelSize().x * 0.5,
                    y: lastPos.y,
                    z: lastPos.z + moveZ,
                });
                break;
            case BASICLENGTHTYPE_ENUM.length2:
                // eslint-disable-next-line no-case-declarations
                const moveX = vector === AXES_TYPE.font
                    ? 0
                    : lastLenghMesh.getModelSize().x;
                meshManage.setModelPosition({
                    x: lastPos.x + lastLenghMesh.getModelSize().x * 0.5 - moveX,
                    y: lastPos.y,
                    z: lastPos.z + lastLenghMesh.getModelSize().z * 0.5 + meshManage.getModelSize().z * 0.5,
                });
                break;
            case BASICLENGTHTYPE_ENUM.length3:
                break;
            default:
                break;
        }
    }
    setSealPlateToManage(sealPlateData, _this) {
        if (!sealPlateData.length)
            return;
        sealPlateData.forEach((item) => {
            const meshManage = new MeshManage(this.scene.getMeshByName(item.id));
            _this.addMesh(meshManage.mesh);
        });
    }
    /**
   *
   * @param {*} templateJson
   * @param {*} lengthSideType lenght1|lenght2|lenght3 哪条边
   * @param {*} lengthType bottom|top 顶柜还是地柜
   * @author: Kun Yang
   * @description 获取一条边上的OtherSealPlateLength
   * @returns 是否存在OtherSealPlateLength
   */
    hasOtherSealPlateLength(templateJSon, lengthSideType, lengthType) {
        var _a, _b;
        return !!((_b = (_a = templateJSon === null || templateJSon === void 0 ? void 0 : templateJSon[lengthType]) === null || _a === void 0 ? void 0 : _a[lengthSideType]) === null || _b === void 0 ? void 0 : _b.otherSealPlateLength);
    }
    /**
     *
     * @param frames 边(length1/length2/length3)的框体数据
     * @param pos 补板位置
     * @description 补板是否是最后一个位置
     * @returns false/true 补板是否是最后一个位置
     */
    checkSealPlateIsLastPos(frames, pos) {
        const filterHightFrames = frames === null || frames === void 0 ? void 0 : frames.filter((frame) => !checkFrameIsHighFrame(frame));
        return (pos === (filterHightFrames === null || filterHightFrames === void 0 ? void 0 : filterHightFrames.length)) || (pos === null);
    }
    /**
     *
     * @param frames 边(length1/length2/length3)的框体数据
     * @param pos 补板位置
     * @description 补板前面是否是水槽柜
     * @returns false/true 补板前面是否是水槽柜
     */
    checkSealPlatePreFrameIsSinkCabinet(frames, pos, lengthType) {
        var _a, _b, _c;
        switch (lengthType) {
            case LengthType.Length1:
                return pos ? !!((_a = frames === null || frames === void 0 ? void 0 : frames[pos - 1]) === null || _a === void 0 ? void 0 : _a.sink) : false;
            case LengthType.Length2:
            case LengthType.Length3:
                if (frames === null || frames === void 0 ? void 0 : frames.length) {
                    return true;
                }
                return pos ? !!((_b = frames === null || frames === void 0 ? void 0 : frames[pos - 1]) === null || _b === void 0 ? void 0 : _b.sink) : false;
            default:
                return pos ? !!((_c = frames === null || frames === void 0 ? void 0 : frames[pos - 1]) === null || _c === void 0 ? void 0 : _c.sink) : false;
        }
    }
}
export default SealPlate;
